module.exports = __webpack_public_path__ + "img/blue-help.6529ddbb.svg";